import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "題目",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "選項",
    isNumber: true,
    isSum: true,
  },
];

export const SexToWeightWaistManagement = {
  label: "性別 vs 體重及腰圍管理",
  key: "SexToWeightWaistManagement",
  path: "BMI/SexToWeightWaistManagement",
  api: "TCS_V_BMIHEBMIV",
  render: (options) => <Diagram.BMI.SexToWeightWaistManagement {...options} />,
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "性別",
      field: "性別",
      header: "",
    },
  ],
  levelColumns,
  columns: [],
};
